export default __webpack_public_path__ + "static/media/GAME-LOGO.2dff74fb.jpg";